import React from "react";
import PropTypes from "prop-types";
// Material imports
import makeStyles from "@mui/styles/makeStyles";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import { useTheme } from "@mui/material/styles";
// Limitless imports
import { useTranslation } from "@limitless/common/hooks/translation/TranslationContext";
import CustomerButton from "../../../customer-button/CustomerButton";
const useStyles = makeStyles(() => {
  return {
    buttonWrapper: {
      height: 36
    },
    compact: {
      transform: "scale(0.90)"
    },
    footerLabels: {
      marginTop: 8
    }
  };
});
const getbuttonStyle = theme => {
  const border = `1px solid ${theme.palette.primary.dark}`;
  const borderLight = `1px solid ${theme.palette.primary.light}30`;
  const selectedColours = {
    backgroundColor: theme.palette.primary.light.includes("rgba") ? theme.palette.primary.light : `${theme.palette.primary.light}30`,
    color: theme.palette.primary.main,
    borderTop: borderLight,
    borderBottom: borderLight,
    borderRight: borderLight,
    borderLeft: borderLight
  };
  const button = {
    borderTop: border,
    borderBottom: border,
    borderLeft: border,
    color: theme.palette.primary.dark,
    minWidth: 26,
    borderRadius: 0,
    borderRight: "none",
    backgroundColor: "transparent",
    height: "auto",
    padding: "6px 8px"
  };
  const leftRadius = {
    borderTopLeftRadius: 5,
    borderBottomLeftRadius: 5,
    borderLeft: border
  };
  const rightRadius = {
    borderTopRightRadius: 5,
    borderBottomRightRadius: 5,
    borderRight: border
  };
  const selected = selectedColours;
  const noBorderLeft = {
    borderLeft: borderLight
  };
  return {
    button,
    rightRadius,
    selected,
    noBorderLeft,
    leftRadius
  };
};
const NumberRatingSystem = ({
  compact = false,
  max = 5,
  onClick,
  rating
}) => {
  const {
    t
  } = useTranslation();
  const [localRating, setLocalRating] = React.useState(rating);
  const [hoverItem, setHoverItem] = React.useState();
  React.useEffect(() => {
    setLocalRating(rating);
  }, [rating]);
  const classes = useStyles();
  const theme = useTheme();
  const handleClick = newRating => {
    setLocalRating(newRating);
    onClick(newRating);
  };
  return /*#__PURE__*/React.createElement(Grid, {
    container: true,
    className: compact ? classes.compact : "",
    justifyContent: "center"
  }, /*#__PURE__*/React.createElement(Grid, {
    display: "flex",
    justifyContent: "space-between"
  }, [...Array(max + 1)].map((_, i) => {
    const isSelected = i === localRating;
    const isNextSelected = hoverItem + 1 === i || localRating + 1 === i;
    const {
      button,
      rightRadius,
      selected,
      noBorderLeft,
      leftRadius
    } = getbuttonStyle(theme);
    let buttonStyle = button;
    if (i === 0) {
      buttonStyle = {
        ...buttonStyle,
        ...leftRadius
      };
    } else if (i === max) {
      buttonStyle = {
        ...buttonStyle,
        ...rightRadius
      };
    }
    if (isSelected || hoverItem === i) {
      buttonStyle = {
        ...buttonStyle,
        ...selected
      };
    }
    if (isNextSelected) {
      buttonStyle = {
        ...buttonStyle,
        ...noBorderLeft
      };
    }
    return /*#__PURE__*/React.createElement(Grid, {
      item: true,
      key: i,
      className: classes.buttonWrapper
    }, /*#__PURE__*/React.createElement(CustomerButton, {
      onClick: () => handleClick(i),
      style: buttonStyle,
      onMouseEnter: () => setHoverItem(i),
      onMouseLeave: () => setHoverItem()
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "body2"
    }, t(i))));
  })), /*#__PURE__*/React.createElement(Grid, {
    container: true,
    justifyContent: "space-between",
    className: classes.footerLabels
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body2"
  }, t("Not at all likely"))), /*#__PURE__*/React.createElement(Grid, {
    item: true
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body2"
  }, t("Extremely likely")))));
};
NumberRatingSystem.propTypes = {
  max: PropTypes.number,
  rating: PropTypes.number,
  onClick: PropTypes.func.isRequired,
  compact: PropTypes.bool
};
export default NumberRatingSystem;